import { AsakusaMap } from "./components/AsakusaMap.js";
import { PinEditor } from "./components/PinEditor.js";

/**
 * ?admin=1 → Pin Editor mode (place, drag, edit pins on the map)
 * Default  → Public map with photo spots
 */
const isAdmin = new URLSearchParams(window.location.search).has("admin");

export default function App() {
  if (isAdmin) return <PinEditor />;
  return <AsakusaMap />;
}
